/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div.row[_ngcontent-%COMP%] {\n  max-height: 800px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcGFnZXMvdXNlci1nZW5lcmF0ZWQtbW9kZXJhdGUtY29tcGFyZS91c2VyLWdlbmVyYXRlZC1tb2RlcmF0ZS1jb21wYXJlLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxpQkFBaUI7QUFDbkIiLCJmaWxlIjoic3JjL2FwcC9wYWdlcy91c2VyLWdlbmVyYXRlZC1tb2RlcmF0ZS1jb21wYXJlL3VzZXItZ2VuZXJhdGVkLW1vZGVyYXRlLWNvbXBhcmUuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbImRpdi5yb3cge1xuICBtYXgtaGVpZ2h0OiA4MDBweDtcbn1cbiJdfQ== */"];
export { styles as styles };
